import classStyle from './BrandDoc.module.scss';
import stapBar2 from '@src/assets/stapBar2.png';
import stapBar4 from '@src/assets/stapBar4.png';
import deposit1 from '@src/assets/deposit1.png';
import deposit2 from '@src/assets/deposit2.png';
import deposit3 from '@src/assets/deposit3.png';
import deposit4 from '@src/assets/deposit4.png';
import deposit5 from '@src/assets/deposit5.png';
import deposit6 from '@src/assets/deposit6.png';
import deposit7 from '@src/assets/deposit7.png';
import deposit8 from '@src/assets/deposit8.png';
import deposit9 from '@src/assets/deposit9.png';
import deposit10 from '@src/assets/deposit10.png';

export const steps = [
    {
        key: 'Deposit',
        title: '- 发起[优币USDT]充值 -',
        stepImg: stapBar4,
        list: [
            {
                text: '第一步：钱包买币到账后，在平台-首页-充值，选择【优币USDT】充值、输入金额、确认充值，获得优币订单信息。',
                imgs: [
                    {
                        img: deposit1,
                    },
                ],
            },
            {
                text: '第二步：打开【优币钱包】应用，打开首页-扫码器（需打开访问相机权限），扫描订单中的二维码。',
                imgs: [
                    {
                        img: deposit2,
                    },
                    {
                        img: deposit3,
                    },
                    {
                        img: deposit4,
                        className: classStyle.contentImgMin,
                    },
                ],
            },
            {
                text: '第三步：扫码后，获取订单信息，输入钱包账号的验证信息，提交。',
                imgs: [
                    {
                        img: deposit5,
                    },
                    {
                        img: deposit6,
                    },
                ],
            },
            {
                text: '第四步：返回平台，稍等片刻，资金即可到账；即完成平台充值USDT。',
            },
        ],
    },
    {
        key: 'Bind',
        text: '[提现前请先绑定哦.]',
        title: '- 绑定【优币钱包】 -',
        stepImg: stapBar2,
        list: [
            {
                text: '第一步：进入【优币钱包】-首页-资产-USDT-”充币”， 选择协议”TRC20”并复制地址， 填到【平台】中并提交进行绑定。\n尤其注意：优币钱包的币种协议，复制粘贴的充币地址。',
                higlights: ['资产', '充币', 'TRC20', '尤其注意'],
            },
            {
                text: '第二步：平台，绑定该地址；即在平台选择优币钱包并提款时，该地址进行收币。',
                imgs: [
                    {
                        img: deposit7,
                    },
                    {
                        img: deposit8,
                    },
                    {
                        img: deposit9,
                    },
                ],
            },
        ],
    },
    {
        key: 'Withdraw',
        title: '-  发起【优币提现】 -',
        stepImg: stapBar2,
        list: [
            {
                text: '第一步：平台，提现页-优币钱包，\n选择【优币钱包地址】及其提现信息，完成验证后，发起提现。',
            },
            {
                text: '第二步：打开【优币钱包】应用，查看【资产】\nUSDT的数字资产，确认资金到账。',
                imgs: [
                    {
                        img: deposit10,
                    },
                ],
            },
        ],
    },
];
